
import * as React from "react";
import map from "lodash/map";
import reverse from "lodash/reverse";
import { getLocalizationSafe } from "../../../../../helpers/localization";
import { lastSeason } from "../../../../../helpers/seasons";
import settings from "../../../../../settings";

import styles from "./Leagues.scss";


const Leagues = () => {
  if (!lastSeason) return null;

  let leagues = map(lastSeason.leagues, (league, index) => {
    return league.icons ? <li key={index} className={styles.clansInfoLeaguesItem}>
                <div>
                    <img className={styles.leagueImage} src={_getImageUrl(league.icons.assembled)} />
                </div>
                <div className={styles.leagueName}>
                    {getLocalizationSafe(league, 'mark')}
                </div>
            </li> : null;
  });

  reverse(leagues);

  return leagues ? <div className={styles.leaguesInfoBlockWrapper}>
            <ul className={styles.leaguesInfoBlock}>
                {leagues}
            </ul>
        </div> : null;
};

const _getImageUrl = (url: string) => {
  if (!url) {
    return '';
  }

  const mediaPath = settings.mediaPath || '';

  return `${mediaPath}${url}`;
};

export default Leagues;